/*!
 * 
 *   @bornfight/gocart v1.0.9
 *   
 * 
 *   Copyright (c) Bornfight (https://www.bornfight.com/)
 * 
 *   This source code is licensed under the MIT license found in the
 *   LICENSE file in the root directory of this source tree.
 *	Add Multiple Triggers
 *   
 */


class GoCart {

    constructor(options) {

        const defaults = {
            cartModalFail: '.js-go-cart-modal-fail',
            cartModalFailClose: '.js-go-cart-modal-fail-close',
            cartModal: '.js-go-cart-modal',
            cartModalClose: '.js-go-cart-modal-close',
            cartModalContent: '.js-go-cart-modal-content',
            cartModalItems: '.go-cart-item__single',
            cartDrawer: '.js-go-cart-drawer',
            cartDrawerContent: '.js-go-cart-drawer-content',
            cartDrawerSubTotal: '.js-go-cart-drawer-subtotal',
            cartPackageProtection: '.nvd-mini',
            cartEmptyState: '.go-cart-empty-state',
            cartDrawerFooter: '.js-go-cart-drawer-footer',
            cartDrawerClose: '.js-go-cart-drawer-close',
            cartMiniCart: '.js-go-cart-mini-cart',
            cartMiniCartContent: '.js-go-cart-mini-cart-content',
            cartMiniCartSubTotal: '.js-go-cart-mini-cart-subtotal',
            cartMiniCartFooter: '.js-go-cart-mini-cart-footer',
            cartTrigger: '.js-go-cart-trigger',
            cartOverlay: '.js-go-cart-overlay',
            cartCount: '.js-go-cart-counter',
            addToCart: '.js-go-cart-add-to-cart',
            removeFromCart: '.js-go-cart-remove-from-cart',
            removeFromCartNoDot: 'js-go-cart-remove-from-cart',
            itemQuantity: '.js-go-cart-quantity',
            itemQuantityPlus: '.js-go-cart-quantity-plus',
            itemQuantityMinus: '.js-go-cart-quantity-minus',
            cartMode: 'drawer',
            drawerDirection: 'right',
            displayModal: false,
            // eslint-disable-next-line no-template-curly-in-string
            moneyFormat: '${{amount}}',
            labelAddedToCart: 'was added to your cart.',
            labelCartIsEmpty: 'Your cart is currently empty. Get shopping!',
            labelQuantity: 'Quantity:',
            labelRemove: 'Remove',
            hiddenItemTag: 'hidden-product',
        };

        this.defaults = Object.assign({}, defaults, options);

        this.cartModalFail = document.querySelector(this.defaults.cartModalFail);
        this.cartModalFailClose = document.querySelector(this.defaults.cartModalFailClose);
        this.cartModal = document.querySelector(this.defaults.cartModal);
        this.cartModalClose = document.querySelectorAll(this.defaults.cartModalClose);
        this.cartModalContent = document.querySelector(this.defaults.cartModalContent);
        this.cartDrawer = document.querySelector(this.defaults.cartDrawer);
        this.cartDrawerContent = document.querySelector(this.defaults.cartDrawerContent);
        this.cartDrawerSubTotal = document.querySelector(this.defaults.cartDrawerSubTotal);
        this.cartPackageProtection = document.querySelector(this.defaults.cartPackageProtection);
        this.cartEmptyState = document.querySelector(this.defaults.cartEmptyState);
        this.cartDrawerFooter = document.querySelector(this.defaults.cartDrawerFooter);
        this.cartDrawerClose = document.querySelector(this.defaults.cartDrawerClose);
        this.cartMiniCart = document.querySelector(this.defaults.cartMiniCart);
        this.cartMiniCartContent = document.querySelector(this.defaults.cartMiniCartContent);
        this.cartMiniCartSubTotal = document.querySelector(this.defaults.cartMiniCartSubTotal);
        this.cartMiniCartFooter = document.querySelector(this.defaults.cartMiniCartFooter);
        this.cartTrigger = document.querySelectorAll(this.defaults.cartTrigger);
        this.cartOverlay = document.querySelector(this.defaults.cartOverlay);
        this.cartCount = document.querySelector(this.defaults.cartCount);
        this.cartCount = document.querySelectorAll(this.defaults.cartCount);
        this.addToCart = document.querySelectorAll(this.defaults.addToCart);
        this.removeFromCart = this.defaults.removeFromCart;
        this.removeFromCartNoDot = this.defaults.removeFromCartNoDot;
        this.itemQuantity = this.defaults.itemQuantity;
        this.itemQuantityPlus = this.defaults.itemQuantityPlus;
        this.itemQuantityMinus = this.defaults.itemQuantityMinus;
        this.cartMode = this.defaults.cartMode;
        this.drawerDirection = this.defaults.drawerDirection;
        this.displayModal = this.defaults.displayModal;
        this.moneyFormat = this.defaults.moneyFormat;
        this.labelAddedToCart = this.defaults.labelAddedToCart;
        this.labelCartIsEmpty = this.defaults.labelCartIsEmpty;
        this.labelQuantity = this.defaults.labelQuantity;
        this.labelRemove = this.defaults.labelRemove;
        this.hiddenItemTag = this.defaults.hiddenItemTag;
        this.setupOrderNoteListeners();
        this.init();

    }

    get isDrawerMode() {
        return this.cartMode === 'drawer';
    }

    init() {

        this.fetchCart();

        if (this.isDrawerMode) {
            this.setDrawerDirection();
        }

        /*
        document.addEventListener('click', (event) => {
            if (event.target.matches(this.defaults.addToCart)) {
                event.preventDefault();
                let item = event.target;
                let form = item.parentNode;
                while ('form' !== form.tagName.toLowerCase()) {
                    form = form.parentNode;
                }
                const formID = form.getAttribute('id');
                this.addItemToCart(formID);
            }
        }, false);
        */

        if (this.addToCart) {
            this.addToCart.forEach((item) => {
                item.addEventListener('click', (event) => {
                    event.preventDefault();
                    let form = item.parentNode;
                    while ('form' !== form.tagName.toLowerCase()) {
                        form = form.parentNode;
                    }
                    const formID = form.getAttribute('id');
                    this.addItemToCart(formID);
                });
            });
        }

        this.cartTrigger.forEach((item) => {
            item.addEventListener('click', () => {
                if (this.isDrawerMode) {
                    this.openCartDrawer();
                } else {
                    this.openMiniCart();
                }
                this.openCartOverlay();
            });
        });


        this.cartOverlay.addEventListener('click', () => {
            this.closeFailModal();
            this.closeCartModal();
            if (this.isDrawerMode) {
                this.closeCartDrawer();
            } else {
                this.closeMiniCart();
            }
            this.closeCartOverlay();
            document.body.style.overflow = "visible";
        });

        if (this.isDrawerMode) {
            this.cartDrawerClose.addEventListener('click', () => {
                this.closeCartDrawer();
                this.closeCartOverlay();
                document.body.style.overflow = "visible";
            });
        }

        if (this.displayModal) {
            this.cartModalClose.forEach((item) => {
                item.addEventListener('click', () => {
                    this.closeFailModal();
                    this.closeCartModal();
                    if (this.isDrawerMode) {
                        this.closeCartDrawer();
                    } else {
                        this.closeMiniCart();
                    }
                    this.closeCartOverlay();
                    document.body.style.overflow = "visible";
                });
            });
        }

        this.cartModalFailClose.addEventListener('click', () => {
            this.closeFailModal();
            this.closeCartModal();
            if (this.isDrawerMode) {
                this.closeCartDrawer();
            } else {
                this.closeMiniCart();
            }
            this.closeCartOverlay();
            document.body.style.overflow = "visible";
        });

    }

    setupOrderNoteListeners() {
        document.querySelector('.js-go-cart-instructions').addEventListener('click', () => {
            const orderNoteSection = document.querySelector('.js-go-cart-drawer__order-note');
            const instructionsButton = document.querySelector('.js-go-cart-instructions');
            orderNoteSection.classList.remove('hidden');
        });

        document.querySelector('.js-go-cart-drawer-order-note-save').addEventListener('click', () => {
            const note = document.getElementById('order-note').value;
            fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ note: note })
            })
            .then(response => {
                if (response.ok) {
                    return response.json();
                }
                throw new Error('Network response was not ok.');
            })
            .then(data => {
                document.querySelector('.js-go-cart-drawer__order-note').classList.add('hidden');
                if (note.length > 0) {
                    document.querySelector('.js-go-cart-instructions').textContent = 'Edit order note';
                } else {
                    document.querySelector('.js-go-cart-instructions').textContent = 'Add a note to your order';
                }
            })
            .catch(error => {
                console.error('There was a problem with the fetch operation: ', error);
            });
        });
    }

    fetchCart(callback) {
        window.fetch('/cart?view=json', {
            credentials: 'same-origin',
            method: 'GET',
        })
            .then((response) => response.text())
            .then((cart) => { eval(cart); this.fetchHandler(window.cart, callback) })
            .catch((error) => {
                this.ajaxRequestFail();
                throw new Error(error);
            });
    }

    getPackCount(product_tags) {
        const priceBreakTag = product_tags.find(tag => tag.startsWith("packcount-"));

        // Check if a price break tag is found
        if (priceBreakTag) {
            // Extract the integer value from the tag
            const integerPart = parseInt(priceBreakTag.split('-')[1]);

            return integerPart;
        }
        return 0;
    }

    isDivisibleByThree(number) {
        return number % 3 === 0;
    }

    checkoutButton(status, total) {
        const checkoutButton = document.querySelector('.go-cart-drawer__footer .go-cart__button');
        const checkoutButtonText = document.querySelector('.go-cart-drawer__footer .go-cart__button span');
        if (checkoutButton) {
            if (status === 'default') {
                checkoutButton.classList.add('disabled');
                checkoutButtonText.innerHTML = `Add ${total} to checkout`;
            }
            if (status === 'disable') {
                checkoutButton.classList.add('disabled');
                checkoutButtonText.innerHTML = `Add ${total} more to checkout`;
            }
            if (status === 'enable') {
                checkoutButton.classList.remove('disabled');
                checkoutButtonText.innerHTML = `Checkout`;
            }
        }
    }


    updateProductShipping(packCount) {
        const packCounter = document.querySelector('.go-cart-drawer .js-go-cart-pack-count');
        packCounter.innerHTML = `${packCount}`;

        // note: updated to use settings scheme to write messages into the DOM and use the below to hide/show the correct message - JG
        // document.querySelectorAll('.go-cart-drawer .js_incentive-message').forEach(function(el) {
        //    el.style.display = 'none';
        // });
        // if (packCount < 13){
        //     const incentive_0_msg = document.querySelector('.go-cart-drawer .js_incentive-message_' + packCount + '');
        //     incentive_0_msg.style.display = 'block';
        // }
        // if (packCount >= 13){
        //   document.querySelector('.go-cart-drawer .js_incentive-message_13').style.display = 'block';
        // }
        // if (packCount === 0){       
        //   this.checkoutButton('default', `3`);
        // }
        // if (packCount === 1) {
        //   this.checkoutButton('disable', `2`);
        // }
        // if (packCount === 2) {
        //   this.checkoutButton('disable', `1`);
        // }
        // if (packCount === 3){
        //   this.checkoutButton('enable');
        // }
        // if (packCount === 4){
        //   this.checkoutButton('disable', `2`);
        // }
        // if (packCount === 5){
        //   this.checkoutButton('disable', `1`);
        // }
        // if (packCount === 6){
        //   this.checkoutButton('enable');
        // }
        // if (packCount === 7) {
        //   this.checkoutButton('disable', `2`);
        // }
        // if (packCount === 8) {
        //   this.checkoutButton('disable', `1`);
        // }
        // if (packCount === 9){
        //   this.checkoutButton('enable');
        // }
        // if (packCount === 10){
        //     this.checkoutButton('disable', `2`);
        // }
        // if (packCount === 11){
        //     this.checkoutButton('disable', `1`);
        // }
        // if (packCount >= 12){
        //     this.checkoutButton('enable');
        // }
    }

    handleOnlyGiftCard(allItemsQuantityExempt) {
        if (allItemsQuantityExempt) {
            this.checkoutButton('enable');
            $(".js_incentive-message").hide();
            $(".js-go-cart-pack-count-wrapper").hide();
        } else {
            $(".js-go-cart-pack-count-wrapper").show();
        }
    }

    addItemToCart(formID) {
        const isObjectEmpty = (objectName) => {
            return Object.keys(objectName).length === 0 && objectName.constructor === Object;
        }
        const form = document.querySelector(`#${formID}`);
        const sellingPlanRadio = document.querySelector('input[name="frequency"]:checked');
        let formData;

        if (sellingPlanRadio) {
            const sellingPlanValue = sellingPlanRadio.value.split('=')[1]; // Split the value by '=' and get the second part
            formData = {
                'id': document.querySelector('input.product-variant-id').value,
                'quantity': document.getElementById('Quantity').value,
                'selling_plan': sellingPlanValue
            };
        } else {
            formData = {
                'id': document.querySelector('input.product-variant-id').value,
                'quantity': document.getElementById('Quantity').value
            };
        }

        const resetQuantityField = () => {
            let quantity = document.getElementById('Quantity');
            if (quantity) {
                quantity.value = 1;
            }
        }
        console.log('adding item')
        return window.fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
        })
            .then((response) => response.json())
            .then((product) => {
                this.addItemToCartHandler(product);
                resetQuantityField();
            })
            .catch((error) => {
                this.ajaxRequestFail();
                throw new Error(error);
            });
    }

    async removeItemsByBundleUid(targetBundleUid) {
        try {
            // Fetch the current cart
            const response = await fetch('/cart.js');
            const cart = await response.json();
    
            // Build the updates object for items with the targetBundleUid and all add-ons
            let updates = {};
    
            cart.items.forEach(item => {
                if (item.properties) {
                    // Remove items with the matching _bundleUid
                    if (item.properties._bundleUid === targetBundleUid) {
                        updates[item.key] = 0;
                    }
                    // Remove all items with the _addon property
                    if (item.properties._addon) {
                        updates[item.key] = 0;
                    }
                }
            });
    
            if (Object.keys(updates).length > 0) {
                // Update the cart to remove the items by setting their quantities to 0
                await fetch('/cart/update.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ updates })
                });
    
                console.log('Bundle and all add-ons have been removed from the cart.');
                this.fetchCart(); // Refresh the cart to reflect the changes
            } else {
                console.log('No matching bundle or add-ons were found in the cart.');
            }
        } catch (error) {
            console.error('Error removing items from cart:', error);
        }
    }
    
    

    removeItems(variantIds) {
        // Construct an updates object where each key is a variant ID and the value is 0
        const updates = variantIds.reduce((acc, variantId) => {
            acc[variantId] = 0;
            return acc;
        }, {});

        window.fetch('/cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ updates }),
        })
            .then(response => response.json())
            .then(data => {
                console.log('Cart updated:', data);
                this.fetchCart(); // Refresh the cart to reflect the changes
            })
            .catch((error) => {
                console.error('Error updating cart:', error);
            });
    }

changeItemQuantity(line, quantity) {
    window.fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        body: JSON.stringify({ quantity, line }),
        headers: {
            'Content-Type': 'application/json',
        },
    })
        .then((response) => response.json())
        .then(() => this.fetchCart())
        .catch((error) => {
            this.ajaxRequestFail();
            throw new Error(error);
        });
}

cartItemCount(cart) {
    // this.cartCount.innerHTML = cart.item_count;
    this.cartCount.forEach((item) => {
        item.innerHTML = cart.item_count;
    });
}

fetchAndOpenCart() {
    console.log('fetching and opening cart');
    this.fetchCart(() => {
        if (this.isDrawerMode) {
            console.log('drawer')
            this.openCartDrawer();
        } else {
            this.openMiniCart();
        }
        this.openCartOverlay();
    });
}

fetchAndOpenModal(product) {
    this.fetchCart(() => {
        this.renderCartModal(product);
        this.openCartModal();
        this.openCartOverlay();
    });
}

fetchHandler(cart, callback) {
    console.log('fetch handler in progress');
    this.cartItemCount(cart);
    if (this.isDrawerMode) {
        this.renderDrawerCart(cart);
        this.cartDrawerFooter.classList.remove('is-invisible');
        if ((typeof callback) === 'function') {
            callback(cart);
        }
        if (cart.item_count === 0) {
            this.renderBlankCartDrawer();
        }
    } else if (cart.item_count === 0) {
        this.renderBlankMiniCart();
        this.cartMiniCartFooter.classList.add('is-invisible');
    } else {
        this.renderMiniCart(cart);
        this.cartMiniCartFooter.classList.remove('is-invisible');
        if ((typeof callback) === 'function') {
            callback(cart);
        }
    }
}

addItemToCartHandler(product) {
    console.log('determining which to open');
    return this.displayModal ? this.fetchAndOpenModal(product) : this.fetchAndOpenCart();
}

ajaxRequestFail() {
    // Clear cookies
    this.deleteAllCookies();

    // Update the modal content to include instructions
    const failContent = document.querySelector('.js-go-cart-modal-fail-content');
    if (failContent) {
        failContent.innerHTML = 'Something went wrong. We have cleared your session for this website. Please refresh the page. If the issue persists, please contact us.';
    }

    // Open the error modal and overlay
    this.openFailModal();
    this.openCartOverlay();

    // Force reload the page with a cache-busting parameter after a short delay
     setTimeout(() => {
        const url = new URL(window.location.href);
        if (!url.searchParams.has('cachebuster')) {
            url.searchParams.append('cachebuster', new Date().getTime());
            window.location.href = url.toString();
        }
    }, 500);
}

deleteAllCookies() {
    const cookies = document.cookie.split(";");

    for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i];
        const eqPos = cookie.indexOf("=");
        const name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;
        // Set the cookie to expire in the past
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${window.location.hostname};`;
    }
}

renderCartModal(product) {
    this.clearCartModal();
    let productVariant = product.variant_title;
    if (productVariant === null) {
        productVariant = '';
    } else {
        productVariant = `(${productVariant})`;
    }
    const cartSingleProduct = `
          <div class="go-cart-modal-item">
            <div class="go-cart-item__image" style="background-image: url(${product.image});"></div>
            <div class="go-cart-item__info">
              ${product.product_title.includes(this.hiddenItemTag) ?
            `<p class="go-cart-item__title">${product.product_title} ${productVariant}</p>` :
            `<a href="${product.url}" class="go-cart-item__title">${product.product_title} ${productVariant}</a>`}
              ${this.labelAddedToCart}
            </div>
          </div>`;
    this.cartModalContent.innerHTML += cartSingleProduct;
}

// Helper function to format price into a money format
formatMoney(amount) {
    // Assuming USD for simplicity; adjust formatting as needed
    return '$' + (amount / 100).toFixed(2);
}

fetchProductDetailsByHandle(bundleHandle) {
    // Access the global variable to find the product details
    const productDetails = window.awtomicProductDetails.find(product => product.handle === bundleHandle);

    if (!productDetails) {
        console.error('Product details not found for handle:', bundleHandle);
        return null; // or some default object structure
    }

    // Assuming productDetails now contains the product you're interested in
    return {
        title: productDetails.title,
        image: productDetails.image
    };
}
renderBundleCartItem(bundleUid, items, cart) {
    // Filter items belonging to the same bundle
    const bundleItems = items.filter(item => item.properties && item.properties._bundleUid === bundleUid);
    console.log(bundleItems);
    // Calculate total price of the bundle
    let bundlePrice = 0;
    let originalBundlePrice = 0; // Initialize original total price
    bundleItems.forEach(item => {
        if (item.final_line_price) {
            bundlePrice += item.final_line_price;
        } else {
            bundlePrice += item.price * item.quantity;
        }
        // Check if selling_plan_allocation exists and has compare_at_price
        if (item.selling_plan_allocation && item.selling_plan_allocation.compare_at_price) {
            originalBundlePrice += item.selling_plan_allocation.compare_at_price * item.quantity;
        } else {
            originalBundlePrice += item.original_price * item.quantity; // Use original_price if compare_at_price is not available
        }
    });

    const bundleHandle = bundleItems[0]?.properties?._bundleHandle;
    const productDetails = this.fetchProductDetailsByHandle(bundleHandle);

    const sellingPlanName = bundleItems[0]?.selling_plan_allocation?.selling_plan?.name;
    // Render HTML for the bundle
    let bundleHtml = `
            <div class="go-cart-item__single go-cart-bundlecart-item" data-bundleuid="${bundleUid}">
                <div class="go-cart-item__info-wrapper">
                    <div class="go-cart-item__image" style="background-image: url(${productDetails.image});"></div>
                    <div class="go-cart-item__info">
                        <div class="go-cart-item__info-top">
                        <div class="go-cart-item__title">${productDetails.title}</div>
                        <div class="go-cart-bundleitems">
                            ${bundleItems.map((item, index) => `
                                <span class="go-cart-bundlesubitem go-cart-bundlesubitem__info" data-line="${index + 1}" data-variant-id="${item.id}"><span class="go-cart-bundlesubitem__title">${item.title}${item.quantity > 1 ? `&nbsp;(x${item.quantity})` : ''}</a></span>`).join(',&nbsp;')}
                        </div>
                        ${sellingPlanName ? `<div class="go-cart-bundle-selling-plan"><strong>Subscription: ${sellingPlanName}</strong></div>` : ''}
                        </div>
                        <div class="go-cart-price-qty body1">
                            <div class="go-cart-item__price h4">
                                ${originalBundlePrice > bundlePrice ? `<span style="text-decoration: line-through;opacity:0.5;">${this.formatMoney(originalBundlePrice)}</span>` : ''}
                                ${this.formatMoney(bundlePrice)}
                            </div>
                        </div>
                    </div>
                </div>
                <a class="h6 go-cart-item__remove ${this.removeFromCartNoDot}">×</a>
            </div>
        `;

    // Append or set this HTML in your cart's HTML
    document.querySelector('.js-go-cart-drawer-content').innerHTML += bundleHtml;
}




renderDrawerCart(cart) {
    console.log('running renderdrawercart');
    this.clearCartDrawer();
    this.cartPackageProtection.classList.remove('hide-children');
    this.cartEmptyState.classList.add('is-invisible');
    let shippingCount = 0;
    let allItemsQuantityExempt = true;
    let bundles_displayed = [];
    cart.items.forEach((item, index) => {
        if (item.properties && item.properties._bundleUid) {
            allItemsQuantityExempt = false;
            if (!bundles_displayed.includes(item.properties._bundleUid)) {
                bundles_displayed.push(item.properties._bundleUid);
                // Render bundle cart item
                this.renderBundleCartItem(item.properties._bundleUid, cart.items, cart);
            }
        } else {
            if (!item.product_tags.includes('quantityexempt')) allItemsQuantityExempt = false;

            let itemVariant = item.variant_title;
            if (itemVariant === null) {
                itemVariant = '';
            }
            const sellingPlanName = item.selling_plan_allocation?.selling_plan?.name;
            const sellingPlanHtml = sellingPlanName ? `<div class="go-cart-item__selling-plan"><strong>Subscription: ${sellingPlanName}</strong></div>` : '';
            const cartSingleProduct = `
                <div class="go-cart-item__single" data-line="${Number(index + 1)}" data-variant-id="${item.id}">
                    <div class="go-cart-item__info-wrapper">
                    <div class="go-cart-item__image" style="background-image: url(${item.image});"></div>
                    <div class="go-cart-item__info">
                        <div class="go-cart-item__info-top">
                        ${item.product_tags.includes(this.hiddenItemTag) ?
                    `<p class="go-cart-item__title">${item.product_title}</p>` :
                    `<a href="${item.url}" class="go-cart-item__title">${item.product_title}</a>`}
                        <div class="go-cart-item__variant body2">${itemVariant}</div>
                        ${sellingPlanHtml}
                        </div>
                        <div class="go-cart-price-qty body1">
                        <div class="go-cart-item__price h4">
                            ${item.original_line_price > item.line_price ? `<span style="text-decoration: line-through;opacity:0.5;">${this.formatMoney(item.original_line_price)}</span>` : ''}
                            ${this.formatMoney(item.line_price)}
                        </div>
                        <div class="go-cart-item__quantity body1 qty-wrap">
                            ${item.product_tags.includes(this.hiddenItemTag) ? "" : `<span class="go-cart-item__quantity-button js-go-cart-quantity-minus min">-</span>`}
                            <input class="go-cart-item__quantity-number js-go-cart-quantity h5 quantity-selector" type="number" value="${item.quantity}" disabled>
                            ${item.product_tags.includes(this.hiddenItemTag) ? "" : `<span class="go-cart-item__quantity-button js-go-cart-quantity-plus plus">+</span>`}
                        </div>
                        </div>
                    </div>
                    </div>
                    <a class="h6 go-cart-item__remove ${this.removeFromCartNoDot}">×</a>
                </div>`;
            this.cartDrawerContent.innerHTML += cartSingleProduct;
        }
        // Shipping Pack Count
        let packCount = this.getPackCount(item.product_tags);
        shippingCount += parseInt(packCount) * parseInt(item.quantity);
        console.log(shippingCount);
    });

    if (cart.items.length == 0) {
        allItemsQuantityExempt = false;
        this.cartDrawer.classList.add('cart-empty');
    } else {
        this.cartDrawer.classList.remove('cart-empty');
    }
    this.updateProductShipping(shippingCount);
    this.handleOnlyGiftCard(allItemsQuantityExempt);
    this.cartDrawerSubTotal.innerHTML = formatMoney(cart.total_price);
    this.cartDrawerSubTotal.parentNode.classList.remove('is-invisible');
    const removeFromCart = document.querySelectorAll(this.removeFromCart);
    removeFromCart.forEach((button) => {
        button.addEventListener('click', () => {
            console.log('Button clicked');
            const parentElement = button.closest('.go-cart-item__single');
            console.log('Parent element:', parentElement);
            if (parentElement.hasAttribute('data-bundleuid')) {
                console.log('Parent element has data-bundleuid attribute');
                const targetBundleUid = parentElement.getAttribute('data-bundleuid');
                this.removeItemsByBundleUid(targetBundleUid);
            } else {            
                console.log('Parent element does not have data-bundleuid attribute');
                // Assuming the parent element has a `data-variant-id` attribute
                const variantId = parentElement.getAttribute('data-variant-id');
                console.log('Variant ID:', variantId);
                this.removeItems([variantId]);
            }
            GoCart.removeItemAnimation(parentElement);
        });
    });
    const itemQuantityPlus = document.querySelectorAll(this.itemQuantityPlus);
    itemQuantityPlus.forEach((item) => {
        item.addEventListener('click', () => {
            const line = item.parentNode.parentNode.parentNode.parentNode.parentNode.getAttribute('data-line');
            const quantity = Number(item.parentNode.querySelector(this.itemQuantity).value) + 1;
            this.changeItemQuantity(line, quantity);
        });
    });
    const itemQuantityMinus = document.querySelectorAll(this.itemQuantityMinus);
    itemQuantityMinus.forEach((item) => {
        item.addEventListener('click', () => {
            const line = item.parentNode.parentNode.parentNode.parentNode.parentNode.getAttribute('data-line');
            const quantity = Number(item.parentNode.querySelector(this.itemQuantity).value) - 1;
            this.changeItemQuantity(line, quantity);
            if (Number((item.parentNode.querySelector(this.itemQuantity).value - 1)) === 0) {
                GoCart.removeItemAnimation(item.parentNode.parentNode.parentNode.parentNode.parentNode);
            }
        });
    });

}

renderMiniCart(cart) {
    this.clearMiniCart();
    cart.items.forEach((item, index) => {
        if (item.properties && item.properties._bundleUid) {
            console.log("found bundle item!");
        }
        // Log all properties of the item
        console.log(item.properties);
        let itemVariant = item.variant_title;
        if (itemVariant === null) {
            itemVariant = '';
        }
        const cartSingleProduct = `
              <div class="go-cart-item__single" data-line="${Number(index + 1)}">
                <div class="go-cart-item__info-wrapper">
                    <div class="go-cart-item__image" style="background-image: url(${item.image});"></div>
                    <div class="go-cart-item__info">
                        ${item.product_tags.includes(this.hiddenItemTag) ?
                `<p class="go-cart-item__title h3">${item.product_title}</p>` :
                `<a href="${item.url}" class="go-cart-item__title h3">${item.product_title}</a>`}
                        <div class="go-cart-item__variant">${itemVariant}</div>
                        <div class="go-cart-item__quantity">
                          ${item.product_tags.includes(this.hiddenItemTag) ? "" : `<span class="go-cart-item__quantity-button js-go-cart-quantity-minus">-</span>`}
                          <input class="go-cart-item__quantity-number js-go-cart-quantity" type="number" value="${item.quantity}" disabled>
                          ${item.product_tags.includes(this.hiddenItemTag) ? "" : `<span class="go-cart-item__quantity-button js-go-cart-quantity-plus">+</span>`}
                        </div>
                    </div>
                </div>
                <div class="go-cart-item__price">${formatMoney(item.line_price, this.moneyFormat)}</div>
                <a class="go-cart-item__remove ${this.removeFromCartNoDot}">${this.labelRemove}</a>
              </div>`;
        this.cartMiniCartContent.innerHTML += cartSingleProduct;
    });
    this.cartMiniCartSubTotal.innerHTML = formatMoney(cart.total_price, this.moneyFormat);
    this.cartMiniCartSubTotal.parentNode.classList.remove('is-invisible');
    const removeFromCart = document.querySelectorAll(this.removeFromCart);
    removeFromCart.forEach((item) => {
        item.addEventListener('click', () => {
            GoCart.removeItemAnimation(item.parentNode);
            const line = item.parentNode.getAttribute('data-line');
            this.removeItem(line);
        });
    });
    const itemQuantityPlus = document.querySelectorAll(this.itemQuantityPlus);
    itemQuantityPlus.forEach((item) => {
        item.addEventListener('click', () => {
            const line = item.parentNode.parentNode.parentNode.parentNode.parentNode.getAttribute('data-line');
            const quantity = Number(item.parentNode.querySelector(this.itemQuantity).value) + 1;
            this.changeItemQuantity(line, quantity);
        });
    });
    const itemQuantityMinus = document.querySelectorAll(this.itemQuantityMinus);
    itemQuantityMinus.forEach((item) => {
        item.addEventListener('click', () => {
            const line = item.parentNode.parentNode.parentNode.parentNode.parentNode.getAttribute('data-line');
            const quantity = Number(item.parentNode.querySelector(this.itemQuantity).value) - 1;
            this.changeItemQuantity(line, quantity);
            if (Number((item.parentNode.querySelector(this.itemQuantity).value - 1)) === 0) {
                GoCart.removeItemAnimation(item.parentNode.parentNode.parentNode.parentNode.parentNode);
            }
        });
    });
}

renderBlankCartDrawer() {
    this.cartPackageProtection.classList.add('hide-children');
    //this.clearCartDrawer();
    this.cartEmptyState.classList.remove('is-invisible');
}

renderBlankMiniCart() {
    this.cartMiniCartSubTotal.parentNode.classList.add('is-invisible');
    this.clearMiniCart();
    this.cartMiniCartContent.innerHTML = `<div class="go-cart__empty">${this.labelCartIsEmpty}</div>`;
}

reloadAjaxContent() {
    this.fetchAndOpenCart();
}

clearCartDrawer() {
    this.cartDrawerContent.innerHTML = '';
}

clearMiniCart() {
    this.cartMiniCartContent.innerHTML = '';
}

clearCartModal() {
    this.cartModalContent.innerHTML = '';
}

openCartDrawer() {
    this.cartDrawer.classList.add('is-open');
}

closeCartDrawer() {
    this.cartDrawer.classList.remove('is-open');
}

openMiniCart() {
    this.cartMiniCart.classList.add('is-open');
}

closeMiniCart() {
    this.cartMiniCart.classList.remove('is-open');
}

openFailModal() {
    this.cartModalFail.classList.add('is-open');
}

closeFailModal() {
    this.cartModalFail.classList.remove('is-open');
}

openCartModal() {
    this.cartModal.classList.add('is-open');
}

closeCartModal() {
    this.cartModal.classList.remove('is-open');
}

openCartOverlay() {
    this.cartOverlay.classList.add('is-open');
}

closeCartOverlay() {
    this.cartOverlay.classList.remove('is-open');
}

    static removeItemAnimation(item) {
    item.classList.add('is-invisible');
}

setDrawerDirection() {
    this.cartDrawer.classList.add(`go-cart__drawer--${this.drawerDirection}`);
}

}

//export default GoCart;

